import { create } from "zustand";

export interface HandoffBundle {
  conversation_id: string;
  lead_name: string | null;
  lead_phone: string | null;
  lead_type: string | null;
  total_score: number | null;
  max_possible_score: number | null;
  sentiment: string | null;
  summary: string;
}

interface UIState {
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
  handoffBundle: HandoffBundle | null;
  setHandoffBundle: (bundle: HandoffBundle | null) => void;
}

export const useUIStore = create<UIState>((set) => ({
  sidebarCollapsed: false,
  toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
  handoffBundle: null,
  setHandoffBundle: (bundle) => set({ handoffBundle: bundle }),
}));
